import React from 'react';
import { Modal, InputNumber, message, Spin, Select } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const Option = Select.Option;

class Update extends React.Component {
    state = {
        loading: false,
        visible: false,
        params: {},
    }

    show = (record) => {
        const { internalRedCreditReason } = record;
        this.setState({
            visible: true,
            params: { 
                ...record,
                internalRedCreditReason: internalRedCreditReason ? internalRedCreditReason : 'HYPHEN_TYPE',
            },
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            loading: false,
            params: {},
        });
    }

    submit = () => {
        const { params } = this.state;
        const { 
            receivingAmountInitial,
            contractBackRecordId,
            internalRedCreditReason,
        } = params;
        if (receivingAmountInitial !== 0 && !receivingAmountInitial) {
            return message.warning('请输入确认收款金额(含税总额)/原币');
        }
        const options = {
            method: 'POST',
            url: API_URL.contract.updateAmountRedCredit,
            data: {
                contractBackRecordId,
                receivingAmountInitial,
                internalRedCreditReason,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.props.loadData();
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    getDataList = () => {
        const {
            params,
        } = this.state;
        const {
            jdecode,
            alphaname,
            addressNumber,
            remark,
            currencyCode,
            grossAmount,
            foreignTaxableAmount,
            internalRedCreditReason,
            receivingAmount,
            receivingAmountInitial,
        } = params;
        const asterisk = <span style={{color: 'red'}}>*</span>;
        const isFIN = sessionStorage.curRole === 'FIN';
        return (
            <div>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>JDE项目号:</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {jdecode}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>客户名称:</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {alphaname}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>客户代码:</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {addressNumber}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>发票号:</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {remark}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>结算币种:</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {currencyCode}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>发票金额（含税总额）总金额:</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {grossAmount}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>外币应税额:</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {foreignTaxableAmount}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>内部红冲原因:</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        <Select
                            placeholder="请选择"
                            style={{ width: 180 }}
                            value={internalRedCreditReason}
                            onChange={value => this.handleChange(value, 'internalRedCreditReason')}
                        >
                            <Option value={'HYPHEN_TYPE'}>-</Option>
                            <Option value={'REBATE_TYPE'}>rebate</Option>
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>确认收款金额(含税总额)/人民币:</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        {receivingAmount}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: '45%' }}>{asterisk}确认收款金额(含税总额)/原币:</div>
                    <div className="item-right" style={{ width: '55%' }}>
                        <InputNumber
                            precision={2}
                            disabled={currencyCode === 'CNY' || !isFIN}
                            step={0.01}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            placeholder='请输入'
                            style={{ width: 180 }}
                            value={receivingAmountInitial}
                            onChange={value => this.handleChange(value, 'receivingAmountInitial')}
                        />
                    </div>
                </li>
            </div>
        )
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title={'修改发票和回款记录'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <Spin spinning={loading}>
                        <ul className="modal-list">
                            { this.getDataList() }
                        </ul>
                    </Spin>
                </div>
            </Modal>
        )    
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/contractManagement/returnedMoney/Update.js